<div
  class="love-it-custom-sort"
  (click)="clicked()">
  <div>{{ name }}</div>
  @if (sortCol !== column || !sortDir) {
    <love-it-generic-icon selector="bi-chevron-expand"></love-it-generic-icon>
  }
  @if (sortCol === column && sortDir === "ASC") {
    <love-it-generic-icon selector="bi-chevron-up"></love-it-generic-icon>
  }
  @if (sortCol === column && sortDir === "DESC") {
    <love-it-generic-icon selector="bi-chevron-down"></love-it-generic-icon>
  }
</div>
